import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQSection() {
  const { t } = useLanguage();

  return (
    <section className="py-24 md:py-32 bg-[#0A0A0A]" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-xs uppercase tracking-[0.25em] text-[#FFD700] mb-4 font-light">{t.faq.overline}</p>
          <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-light text-white tracking-tight">{t.faq.title}</h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {t.faq.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="bg-[#121212] border border-white/10 px-6 data-[state=open]:border-[#FFD700]/30"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-white text-left font-light hover:text-[#FFD700] text-sm md:text-base py-5 hover:no-underline">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-zinc-400 text-sm font-light leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
